import React, { FC, ReactNode } from 'react';

import { NavLink } from 'react-router-dom';

import styles from './navigation-link.module.scss';

import { Headline4 } from 'views/components/UI';

interface INavigationLink {
  to: string;
  children: ReactNode;
}

const NavigationLink: FC<INavigationLink> = ({ to, children }) => (
  <NavLink className={styles.link} to={to} activeClassName={styles.active}>
    <Headline4 className={styles.link__label}>{children}</Headline4>
  </NavLink>
);

export { NavigationLink };
